import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { toast } from 'react-toastify';
import { get } from 'lodash';

import { Modal } from '~/components';

import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { isArray, isEmpty } from 'lodash';
import * as Yup from 'yup';

import Tabela from '../Tabela';

import { Table } from '~/components';

import { Form, Input, Autocomplete } from '~/components/Form'
import { t } from '~/helpers';
import api from '~/services/api';

import qs from 'querystring';

import * as S from './styles';

import {
  TextField,
  Button,
  MenuItem,

} from '@material-ui/core';


import {
  deleteoperacaobloqueioprefaturageradaitem,
  recordFilteringVeiculo,
  findVeiculosBloqueadosPreFaturaGerada,
  veiculosBloqueadosPreFaturaGeradaInRequest,
} from '~/store/modules/operacaobloqueioprefaturageradaitem/actions';

import AdicionarBloqueio from '../AdicionarBloqueio'
import RemoverBloqueio from '../RemoverBloqueio'

export default function AdmFormPreFaturaGerada({ data }) {
  const formRef = useRef(null);

  // const operacaobloqueioprefaturageradaitem = useSelector(
  //   (state) => state.operacaobloqueioprefaturageradaitem
  // );

  const [itemSelecionado, setItemSelecionado] = React.useState({});
  const [itemPreFatura, setItemPreFatura] = useState([]);
  const [itensFaturaVeiculoHistorico, setItensFaturaVeiculoHistorico] = useState([]);

  const [loading, setLoading] = useState(false);

  const [btnEditarMI, setBtnEditarMI] = React.useState(false);
  const [btnEditarMR, setBtnEditarMR] = React.useState(false);

  const adicionarBloqueioRef = useRef(null);
  const removerBloqueioRef = useRef(null);



  const handleGetItemPreFatura = useCallback(async () => {
    try {

      let params = {};

      let dadosItemPreFatura = [];

      params = {
        //fieldlist: 'fatu_codigo, veic_placa, ftit_fatura_str',
        wherefield: ['fatu_codigo'],
        typewherefield: ['EQUALS'],
        valuewherefield: [data.fatu_codigo],
        orderfield: 'veic_placa',
        pagesize: 99999,
      }

      const responseItens = await api.get('operacaobloqueioprefaturageradaitemhistoricoitem', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      dadosItemPreFatura = responseItens.data.items;

      setItemPreFatura(dadosItemPreFatura);


      //const response = await api.get(`cotaunidade/${unity.unid_codigo}/${unity.orga_codigo}/${product}`);

      // if (!isEmpty(response.data)) setBalance(response.data.coun_cota);
      // else setBalance(0);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);


  const handleGetItemPreFaturaVeiculoHistorico = useCallback(async (fatu_codigo) => {
    try {

      let params = {};

      let dadosItemPreFaturaVeiculoHistorico = [];

      params = {
        //fieldlist: 'apbf_data_evento_str, apbf_acao_str,apbf_login_executante,apbf_observacao',
        wherefield: ['fatu_codigo'],
        typewherefield: ['EQUALS'],
        valuewherefield: [fatu_codigo],
        orderfield: 'veic_placa',
        pagesize: 99999,
      }

      const responseItensHistorico = await api.get('operacaobloqueioprefaturageradaitem', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      dadosItemPreFaturaVeiculoHistorico = responseItensHistorico.data.items;

      setItensFaturaVeiculoHistorico(dadosItemPreFaturaVeiculoHistorico);


      //const response = await api.get(`cotaunidade/${unity.unid_codigo}/${unity.orga_codigo}/${product}`);

      // if (!isEmpty(response.data)) setBalance(response.data.coun_cota);
      // else setBalance(0);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [data]);

  useEffect(() => {
    handleGetItemPreFatura();
  }, [data]);

  // useEffect(() => {
  //   if (product && !isEmpty(unity)) handleGetBalance();
  // }, [product, unity]);


  const header = [
    {
      id: 'veic_placa',
      label: 'Veículo',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'ftit_fatura_str',
      label: 'Estado',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
  ];



  const headerDetalheVeiculo = [
    {
      id: 'apbf_data_evento_str',
      label: 'Data',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_acao_str',
      label: 'Status',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_login_executante',
      label: 'Login',
      filter: {
        type: 'text',
      },
      align: 'left',
    },
    {
      id: 'apbf_observacao',
      label: 'Observação',
      filter: {
        type: 'text',
      },
      align: 'center',
    },
  ];



  const registroSelecionado = React.useCallback((values) => {
    if ((values)) {
      setItemSelecionado(values);
      controleAcaoBtnMenu(values);
    } else {
      setItemSelecionado({});
      setBtnEditarMI(false);
      setBtnEditarMR(false);
    }
  }, [data, itemPreFatura]);

  const registroPaginacao = React.useCallback((values) => {
    setItemSelecionado({});
    setBtnEditarMI(false);
    setBtnEditarMR(false);
  }, [data, itemPreFatura]);


  const controleAcaoBtnMenu = React.useCallback((values) => {
    //if (profile.glousuariotipo === ADM) {
    if (values.ftit_fatura === 'N') {
      setBtnEditarMI(false);
      setBtnEditarMR(true);
    } else {
      setBtnEditarMI(true);
      setBtnEditarMR(false);
    }
  }, [data, itemPreFatura]);

  const handleCloseModal = React.useCallback(() => {
    handleGetItemPreFatura();
  }, [data, itemPreFatura]);


  return (
    //<Form ref={formRef} onSubmit={handleSubmit} initialData={data}>
    <S.Wrapper>

      <S.WrapperCabecalho>
        <p>
          {/* //Pré-fatura..: {(data.fatu_codigo !== undefined ) ? data.fatu_codigo:''} */}
          Pré-fatura..: {get(data, 'fatu_codigo', '')}
        </p>
        {/* </S.WrapperCabecalho>
      <S.WrapperCabecalho> */}
        <p>
          Órgão..........: {get(data, 'orga_sigla', '')}
          {/* Órgão..........: {(data.orga_sigla !== undefined) ? data.orga_sigla: ''} */}
        </p>
      </S.WrapperCabecalho>

      <S.WrapperGroupButton>
        <Button
          onClick={() => { adicionarBloqueioRef.current.handleOpenModal({ data: itemSelecionado }) }}
          color="primary"
          variant="outlined"
          disabled={!(btnEditarMI)}
        >
          {'Incluir Bloqueio'}
        </Button>


        <Button
          onClick={() => { removerBloqueioRef.current.handleOpenModal({ data: itemSelecionado }) }}
          color="primary"
          variant="outlined"
          disabled={!(btnEditarMR)}
        >
          {'Retirar Bloqueio'}
        </Button>
      </S.WrapperGroupButton>

      <Tabela
        loading={loading}
        cells={header}
        data={itemPreFatura}
        size="small"
        showPagination={true}
        showCount
        search
        paginate={8}
        onCallback={(values) => registroSelecionado(values)}
        onCallbackNewPage={(values) => registroPaginacao(values)}

      //onCallback={(values) => registroSelecionado(values)}
      />

      <Modal
        ref={adicionarBloqueioRef}
        form
        disableBackdropClick
        disableEscapeKeyDown
        component={AdicionarBloqueio}
        title="Adicionar Bloqueio"
        loading={loading}
        maxWidth="sm"
        onClose={() => handleCloseModal()}
      //form
      // actions={[
      //   {
      //     label: t('s.geral.botaofechar'),
      //     callback: () => adicionarBloqueioRef.current.handleCloseModal(),
      //     color: 'secondary'
      //   }
      // ]}
      />

      <Modal
        ref={removerBloqueioRef}
        form
        disableBackdropClick
        disableEscapeKeyDown
        component={RemoverBloqueio}
        title="Remover Bloqueio"
        loading={loading}
        maxWidth="sm"
        onClose={() => handleCloseModal()}
      //form
      // actions={[
      //   {
      //     label: t('s.geral.botaofechar'),
      //     callback: () => removerBloqueioRef.current.handleCloseModal(),
      //     color: 'secondary'
      //   }
      // ]}

      />

    </S.Wrapper>
    //</Form>
  );
}

AdmFormPreFaturaGerada.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
}
